// IF YOU CHANGE THIS FILE, YOU MUST ALSO CHANGE THE FILE IN THE NEXT LOCATIONS:
//  - portal-backend - src/modules/sitemap/localized-paths.ts
import type { AvailableLocale } from '@/i18n/types'

export const en = {
    game: 'game/:game',
    category: 'category/:hru',
    tag: 'tag/:hru',
    developer: 'developer/:hru',
    collection: 'collections/:hru',
    series: 'series/:hru',
    contacts: 'contacts',
    profile: 'profile',
    shop: 'shop',
    invite: 'invite/:inviteCode',
    allCategories: 'all/categories',
    allTags: 'all/tags',
    allSeries: 'all/series',
    confidential: 'confidential',
    termsofuse: 'termsofuse',
    termsofuse_mcm: 'mcm-termsofuse',
    takedown_notice: 'takedown-notice',
    license: 'license',
    partners_api: 'partners-api',
    myGames: 'my-games',
    steamGames: 'steam-games',
    digitalServiceAct: 'digital-service-act',
    leaderboardsInfo: 'leaderboards-info',
    search: 'search',
}

export type LocalizedPaths = typeof en

const es: LocalizedPaths = {
    game: 'juego/:game',
    category: 'categoria/:hru',
    tag: 'etiqueta/:hru',
    developer: 'desarrollador/:hru',
    collection: 'collections/:hru',
    series: 'serie/:hru',
    contacts: 'contactos',
    profile: 'perfil',
    shop: 'tienda',
    invite: 'invitar/:inviteCode',
    allCategories: 'todas/categorias',
    allTags: 'todas/etiquetas',
    allSeries: 'todas/series',
    confidential: 'confidencial',
    termsofuse: 'terminosdeuso',
    termsofuse_mcm: 'mcm-terminosdeuso',
    takedown_notice: 'aviso-de-eliminacion',
    license: 'licencia',
    partners_api: 'api-de-socios',
    myGames: 'mis-juegos',
    steamGames: 'juegos-steam',
    digitalServiceAct: 'ley-de-servicios-digitales',
    leaderboardsInfo: 'info-clasificaciones',
    search: 'buscar',
}

const de: LocalizedPaths = {
    game: 'spiel/:game',
    category: 'kategorie/:hru',
    tag: 'tag/:hru',
    developer: 'entwickler/:hru',
    collection: 'collections/:hru',
    series: 'serie/:hru',
    contacts: 'kontakte',
    profile: 'profil',
    shop: 'laden',
    invite: 'einladen/:inviteCode',
    allCategories: 'alle/kategorien',
    allTags: 'alle/tags',
    allSeries: 'alle/serien',
    confidential: 'vertraulich',
    termsofuse: 'nutzungsbedingungen',
    termsofuse_mcm: 'mcm-nutzungsbedingungen',
    takedown_notice: 'entfernungsmitteilung',
    license: 'lizenz',
    partners_api: 'partner-api',
    myGames: 'meine-spiele',
    steamGames: 'steam-spiele',
    digitalServiceAct: 'gesetz-uber-digitale-dienste',
    leaderboardsInfo: 'bestenlisten-info',
    search: 'suche',
}

const fr: LocalizedPaths = {
    game: 'jeu/:game',
    category: 'categorie/:hru',
    tag: 'tag/:hru',
    developer: 'développeur/:hru',
    collection: 'collections/:hru',
    series: 'serie/:hru',
    contacts: 'contacts',
    profile: 'profil',
    shop: 'boutique',
    invite: 'inviter/:inviteCode',
    allCategories: 'toutes/categories',
    allTags: 'toutes/tags',
    allSeries: 'toutes/series',
    confidential: 'confidentiel',
    termsofuse: 'conditions-dutilisation',
    termsofuse_mcm: 'mcm-conditions-dutilisation',
    takedown_notice: 'avis-de-retrait',
    license: 'licence',
    partners_api: 'api-partenaires',
    myGames: 'mes-jeux',
    steamGames: 'jeux-steam',
    digitalServiceAct: 'loi-sur-les-services-numeriques',
    leaderboardsInfo: 'info-classements',
    search: 'recherche',
}

const it: LocalizedPaths = {
    game: 'gioco/:game',
    category: 'categoria/:hru',
    tag: 'tag/:hru',
    developer: 'sviluppatore/:hru',
    collection: 'collections/:hru',
    series: 'serie/:hru',
    contacts: 'contatti',
    profile: 'profilo',
    shop: 'negozio',
    invite: 'invita/:inviteCode',
    allCategories: 'tutte/categorie',
    allTags: 'tutte/tag',
    allSeries: 'tutte/serie',
    confidential: 'riservato',
    termsofuse: 'termini-di-uso',
    termsofuse_mcm: 'mcm-termini-di-uso',
    takedown_notice: 'avviso-di-rimozione',
    license: 'licenza',
    partners_api: 'api-partner',
    myGames: 'i-miei-giochi',
    steamGames: 'giochi-steam',
    digitalServiceAct: 'legge-sui-servizi-digitali',
    leaderboardsInfo: 'info-classifiche',
    search: 'ricerca',
}

const ptBr: LocalizedPaths = {
    game: 'jogo/:game',
    category: 'categoria/:hru',
    tag: 'tag/:hru',
    developer: 'desenvolvedor/:hru',
    collection: 'collections/:hru',
    series: 'serie/:hru',
    contacts: 'contatos',
    profile: 'perfil',
    shop: 'loja',
    invite: 'convidar/:inviteCode',
    allCategories: 'todas/categorias',
    allTags: 'todas/tags',
    allSeries: 'todas/series',
    confidential: 'confidencial',
    termsofuse: 'termos-de-uso',
    termsofuse_mcm: 'mcm-termos-de',
    takedown_notice: 'aviso-de-remocao',
    license: 'licenca',
    partners_api: 'api-parceiros',
    myGames: 'meus-jogos',
    steamGames: 'jogos-steam',
    digitalServiceAct: 'lei-dos-servicos-digitais',
    leaderboardsInfo: 'info-rankings',
    search: 'pesquisar',
}

const tr: LocalizedPaths = {
    game: 'oyun/:game',
    category: 'kategori/:hru',
    tag: 'etiket/:hru',
    developer: 'gelistirici/:hru',
    collection: 'collections/:hru',
    series: 'seri/:hru',
    contacts: 'iletisim',
    profile: 'profil',
    shop: 'magaza',
    invite: 'davet/:inviteCode',
    allCategories: 'tum/kategoriler',
    allTags: 'tum/etiketler',
    allSeries: 'tum/seriler',
    confidential: 'gizli',
    termsofuse: 'kullanim-kosullari',
    termsofuse_mcm: 'mcm-kullanim-kosullari',
    takedown_notice: 'kaldirma-bildirimi',
    license: 'lisans',
    partners_api: 'ortaklar-api',
    myGames: 'oyunlarim',
    steamGames: 'steam-oyunlari',
    digitalServiceAct: 'dijital-hizmetler-yasasi',
    leaderboardsInfo: 'liderlik-tablolari-bilgi',
    search: 'ara',
}

const pl: LocalizedPaths = {
    game: 'gra/:game',
    category: 'kategoria/:hru',
    tag: 'tag/:hru',
    developer: 'deweloper/:hru',
    collection: 'collections/:hru',
    series: 'seria/:hru',
    contacts: 'kontakty',
    profile: 'profil',
    shop: 'sklep',
    invite: 'zaproszenie/:inviteCode',
    allCategories: 'wszystkie/kategorie',
    allTags: 'wszystkie/tagi',
    allSeries: 'wszystkie/serie',
    confidential: 'poufne',
    termsofuse_mcm: 'mcm-warunki-uzytkowania',
    termsofuse: 'warunki-uzytkowania',
    takedown_notice: 'powiadomienie-o-usunieciu',
    license: 'licencja',
    partners_api: 'api-partnerow',
    myGames: 'moje-gry',
    steamGames: 'gry-steam',
    digitalServiceAct: 'ustawa-o-uslugach-cyfrowych',
    leaderboardsInfo: 'rankingi-info',
    search: 'szukaj',
}

const id: LocalizedPaths = {
    game: 'permainan/:game',
    category: 'kategori/:hru',
    tag: 'tag/:hru',
    developer: 'developer/:hru',
    collection: 'collections/:hru',
    series: 'seri/:hru',
    contacts: 'kontak',
    profile: 'profil',
    shop: 'toko',
    invite: 'undang/:inviteCode',
    allCategories: 'semua/kategori',
    allTags: 'semua/tag',
    allSeries: 'semua/seri',
    confidential: 'rahasia',
    termsofuse: 'ketentuan-penggunaan',
    termsofuse_mcm: 'mcm-ketentuan-penggunaan',
    takedown_notice: 'pemberitahuan-penghapusan',
    license: 'lisensi',
    partners_api: 'api-mitra',
    myGames: 'permainanku',
    steamGames: 'permainan-steam',
    digitalServiceAct: 'undang-undang-layanan-digital',
    leaderboardsInfo: 'info-papan-peringkat',
    search: 'cari',
}

export const allLocalizedPaths: Record<AvailableLocale, LocalizedPaths> = {
    'en-US': en,
    'es-ES': es,
    'de-DE': de,
    'fr-FR': fr,
    'it-IT': it,
    'pt-BR': ptBr,
    'tr-TR': tr,
    'pl-PL': pl,
    'id-ID': id,
}
